import React, { useState, useEffect, useRef, useContext } from "react";
import Config from "../../Config";
import swal from "sweetalert";
import { withRouter, useHistory, Redirect } from "react-router-dom";
import { PageSettings } from "../../config/page-settings";
import { useAuth0 } from "@auth0/auth0-react";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";

import {
  getUsrActivePackageDetail
} from "../../api/packageApi";
import webAuth from "../utils/auth0";
// import { Auth0Login } from "../../api/loginApi";
// import axios from "axios";
// import toastr from "toastr";
var axios = require("axios").default;

const Login1 = (props) => {
  let history = useHistory();
  const context = useContext(PageSettings);
  const [type, settype] = useState("password");
  const [score, setscore] = useState(null);
  const [_id, set_id] = useState("");
  // const [Email, setEmail] = useState("eddycase1+admin@hotmail.com");
  // const [Password, setPassword] = useState("Password123$$$$");
  const [Password, setPassword] = useState("Eglaf@123");
  const [Email, setEmail] = useState("rprajapati@eagletechsolutions.uk");
  const [EmailError, setEmailError] = useState("");

  const [PasswordError, setPasswordError] = useState("");

  const [roleName, setroleName] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [fetching, setFetching] = React.useState(false);
  const [UserPackageInfo, setUserPackageInfo] = useState(null);
  const {
    user,
    isAuthenticated,
    getAccessTokenSilently,
    error,
    isLoading,
    logout,
  } = useAuth0();

  const { loginWithRedirect } = useAuth0();
  useEffect(() => {
    // localStorage.setItem('islogin', false);
    // localStorage.removeItem('loginName');
    // localStorage.removeItem('loginUserID');
    // localStorage.removeItem('loginEmail');
    // localStorage.removeItem('loginRoleName');
    // localStorage.clear();
  }, []);

  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetPageContentFullWidth(true);
    return () => {
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetPageContentFullWidth(false);
    };
  }, []);



  const GetUsrActivePackageDetail = async () => {
    let Rolename = localStorage.getItem("loginRoleName");
    if (Rolename === "Admin") {
      try {
        let data = await getUsrActivePackageDetail();
        if (data != null && data?._id !== null && data?._id !== "" && data?._id !== undefined) {
          console.log("GetUserPackage===>", data)
            if(data?.isActive === false){
              history.push("/Pricingpage");
            }
            else{
              history.push("/home");
            }
        }
        else{
          history.push("/home");
        }

      } catch (error) {
        console.log("getPackageE5rror==>", error)
      }
    }

  };
  useEffect(() => {
    const getdata = async () => {
      let checkLogin = await localStorage.getItem("loginUserID");
      if (
        checkLogin === "" ||
        checkLogin === "" ||
        checkLogin === undefined ||
        checkLogin === null
      ) {
        loginWithRedirect();
      } else {

        if (!isLoading && isAuthenticated) {

          let Rolename = localStorage.getItem("loginRoleName");
          localStorage.removeItem('Pricingpage');
          if (Rolename === "SuperAdmin") {
            history.push("/superdashboard");
          } else {
            GetUsrActivePackageDetail();
          }
        }
        else if (!isLoading && !isAuthenticated) {
          localStorage.removeItem('Pricingpage');
          let Rolename = localStorage.getItem("loginRoleName");
          if (Rolename === "SuperAdmin") {
            history.push("/superdashboard");
          } else {
            GetUsrActivePackageDetail();
          }
        }
      }
    }
    getdata().catch(console.error);

  }, [isAuthenticated, isLoading]);

  const callLogout = async () => {
    await logout()
  }


  const onChangeEmail = (event) => {
    setEmailError("");
    setEmail(event.target.value);
  };

  const onChangePassword = (event) => {
    setPasswordError("");
    setPassword(event.target.value);
  };

  

  const CreateLogin = async (email, name, token, auth0id) => {
    let isvalid = true;
    if (email === null || email === undefined || email === "") {
      isvalid = false;
    }
    if (isvalid === true) {
      var createModel = {
        email: email,
        name: name,
        Auth0ID: auth0id,
        FCMToken: "",
      };

      fetch(
        Config.apiUrl +
        "UserCompany/AuthCreateUserCompany",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify(createModel),
        }
      )
        .then((result) => {
          result.json().then((resp) => {
            console.log("Praveenresponxe=>", resp);
            if (resp?.id != undefined && resp?.id != null && resp?.id != "") {

              localStorage.setItem("islogin", true);
              localStorage.setItem("loginName", resp?.name);
              localStorage.setItem("Auth0ID", auth0id);
              localStorage.setItem("loginUserID", resp?.id);
              localStorage.setItem("subUserIDList", resp?.subUserIDList);
              localStorage.setItem("loginEmail", resp?.email);
              localStorage.setItem("loginRoleName", resp?.roleName);
              localStorage.setItem("UserCompanyId", resp?.parentID);
              localStorage.setItem(
                "loginUserImage",
                Config.contentUrl + resp?.userImage
              );
              localStorage.setItem("Auth0token", token);
              if (resp?.roleName === "SuperAdmin") {
                // history.push("/supperadmin/superdashboard");
                history.push("/superdashboard");
              } else {
                // history.push("/dashboard/home");
                history.push("/home");
              }

              //this.props.history.push({ pathname: '/dashboard/home' });
            } else {
              history.push("/Logout");
              swal("Your Email And Password invalid !");
            }
          });
        })
        .catch((error) => {
          swal("error !" + error);
          console.error("There was an error!", error);
          history.push("/Logout");
        });
    } else {
      history.push("/Login");
    }
  };
  // const CreateLogin = (email, token) => {
  //     let isvalid = true;
  //     if (email === null || email === undefined || email === "") {
  //         isvalid = false;
  //     }

  //     if (isvalid === true) {
  //         fetch(Config.apiUrl + "UserCompany/GetFullUserDetailByEmailAddress?email=" + email,
  //             {
  //                 method: "GET",
  //                 headers: {
  //                     'Content-Type': 'application/json',
  //                     'Access-Control-Allow-Origin': '*'
  //                 },
  //             }).then((result) => {
  //                 result.json().then((resp) => {
  //                     if (resp?.id != undefined && resp?.id != null && resp?.id != "") {
  //                         localStorage.setItem('islogin', true);
  //                         localStorage.setItem('loginName', resp.name);
  //                         localStorage.setItem('loginUserID', resp.id);
  //                         localStorage.setItem('loginEmail', resp.email);
  //                         localStorage.setItem('loginRoleName', resp.roleName);
  //                         localStorage.setItem('loginUserImage', Config.contentUrl + resp.userImage);
  //                         localStorage.setItem('Auth0token', token);
  //                         history.push('/dashboard/home');

  //                         //this.props.history.push({ pathname: '/dashboard/home' });
  //                     }
  //                     else {
  //                         history.push('/Login');
  //                         swal("Your Email And Password invalid !");
  //                     }
  //                 })
  //             }).catch((error) => {
  //                 swal("error !" + error);
  //                 console.error('There was an error!', error);
  //                 history.push('/Login');
  //             })
  //     }
  //     else {
  //         history.push('/Login');
  //     }
  // }

  // const CreateLogin = () => {
  //     let isvalid = true;
  //     if (Email === null || Email === undefined || Email === "") {
  //         isvalid = false;
  //         setEmailError('please enter email address')
  //     }
  //     if (Password === null || Password === undefined || Password === "") {
  //         isvalid = false;
  //         setPasswordError('please enter password')
  //     }
  //     if (isvalid === true) {
  //         var data = {
  //             Email: Email,
  //             Password: Password
  //         }
  //         console.log("LoginData_", data)
  //         fetch(Config.apiUrl + "UserCompany/Login",
  //             {
  //                 method: "POST",
  //                 headers: {
  //                     'Content-Type': 'application/json',
  //                     'Access-Control-Allow-Origin': '*'
  //                 },
  //                 body: JSON.stringify(data)
  //             }).then((result) => {
  //                 result.json().then((resp) => {
  //                     if (resp.id != undefined && resp.id != null && resp.id != "") {
  //                         localStorage.setItem('islogin', true);
  //                         localStorage.setItem('loginName', resp.name);
  //                         localStorage.setItem('loginUserID', resp.id);
  //                         localStorage.setItem('loginEmail', resp.email);
  //                         localStorage.setItem('loginRoleName', resp.roleName);
  //                         localStorage.setItem('loginUserImage', Config.contentUrl + resp.userImage);
  //                         history.push('/');

  //                         //this.props.history.push({ pathname: '/dashboard/home' });
  //                     }
  //                 })
  //             }).catch((error) => {
  //                 swal("Your Email And Password invalid !");
  //                 console.error('There was an error!', error);
  //             })
  //     }
  // }

  // const AuthoLogin = async () => {
  //   if (Email === null || Email === undefined || Email === "") {
  //     setEmailError("please enter email address");
  //     return;
  //   }
  //   if (Password === null || Password === undefined || Password === "") {
  //     setPasswordError("please enter password");
  //     return;
  //   }

  //   var options = {
  //     method: "POST",
  //     url: "https://dev-3yjin90z.us.auth0.com/oauth/token",
  //     headers: { "content-type": "application/x-www-form-urlencoded" },
  //     data: new URLSearchParams({
  //       grant_type: "password",
  //       username: Email,
  //       password: Password,
  //       audience:
  //         "https://stt-api-stage.eagletechsolutions.uk/weatherforecast/",
  //       scope: "read:sample",
  //       client_id: "CQK7qF4iOl90HWaIVX3iTljiGMFbP02P",
  //       client_secret: "CQK7qF4iOl90HWaIVX3iTljiGMFbP02P",
  //     }),
  //   };
  //   axios
  //     .request(options)
  //     .then(function (response) {
  //       console.log(response.data);
  //     })
  //     .catch(function (error) {
  //       console.error(error);
  //     });
  //   // setFetching(true);
  //   // webAuth.client.login(
  //   //   {
  //   //     // realm: "Username-Password-Authentication",
  //   //     realm: "acme",
  //   //     username: Email,
  //   //     password: Password,
  //   //     // responseType: "token",
  //   //     responseType: "client_credentials",
  //   //   },
  //   //   function (err, result) {
  //   //     setFetching(false);
  //   //     if (err) {
  //   //       //setError(err)
  //   //       // toastr.warning(err.description);
  //   //     } else {
  //   //       if (result?.accessToken) {
  //   //         let Auth0Data = parseJwt(result?.accessToken);
  //   //       } else {
  //   //         // toastr.warning("token not found");
  //   //       }
  //   //     }
  //   //   }
  //   // );
  //   //let response = await Auth0Login(Email, Password);
  // };

  // const Authosingup = async () => {
  //   if (Email === null || Email === undefined || Email === "") {
  //     setEmailError("please enter email address");
  //     return;
  //   }
  //   if (Password === null || Password === undefined || Password === "") {
  //     setPasswordError("please enter password");
  //     return;
  //   }

  //   webAuth.signup(
  //     {
  //       realm: "Username-Password-Authentication",
  //       email: Email,
  //       password: Password,
  //       connection: "con_vwULODbBG5A8n2bU",
  //     },
  //     function (err, result) {
  //       setFetching(false);
  //       if (err) {
  //         //setError(err)
  //         // toastr.warning(err.description);
  //       } else {
  //         if (result?.accessToken) {
  //           let Auth0Data = parseJwt(result?.accessToken);
  //         } else {
  //           // toastr.warning("token not found");
  //         }
  //       }
  //     }
  //   );
  // };
  // const parseJwt = (token) => {
  //   // const token = localStorage.getItem("accessToken");
  //   var base64Url = token.split(".")[1];
  //   var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  //   var jsonPayload = decodeURIComponent(
  //     window
  //       .atob(base64)
  //       .split("")
  //       .map(function (c) {
  //         return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  //       })
  //       .join("")
  //   );

  //   return JSON.parse(jsonPayload);
  // };

  const showHide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    settype(type === "input" ? "password" : "input");
  };
  // ------ for free trial
  // swal({
  //     title: "Your trial period will end in 12 days",
  //     text: "Please select your package to continue , Go to setting, package and billing and select your package",
  //     icon:'info',
  //     button: "ok",
  //   });

  if (isLoading) {
    return <LoaderSpinner isrefresh={isLoading} />;
  }

  return (
    <div className="login login-with-news-feed">

    </div>
  );
};

export default Login1;
